import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { reduxForm, initialize, destroy } from 'redux-form'
import { CharField, FieldError, CheckboxField } from 'components/forms'
import { Button, SvgSpriteSheet } from 'components/util'
import * as auth from 'services/auth/selectors'
import styles from 'components/migration/_migrate.css'

export const FORM_NAME = 'login'

const validate = (values) => {
  const errors = {}
  if (!values.email) { errors.email = 'required' }
  if (!values.password) { errors.password = 'required' }
  if (!values.agreement) { errors.agreement = 'required' }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  onboardingEmail: auth.selectOnboardingEmail(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class MigrateForm extends Component {
  static propTypes = {
    initialize: PropTypes.func,
    loggingIn: PropTypes.bool,
    handleSubmit: PropTypes.func,
    onLoginSuccess: PropTypes.func,
    error: PropTypes.object,
    onboardingEmail: PropTypes.string,
    confirmPage: PropTypes.bool,
  }

  componentWillMount () {
  }

  render () {
    const { handleSubmit, loggingIn, error } = this.props

    return (
      <form method='post' onSubmit={handleSubmit} className={styles.migrateForm}>
        {error ?
          <FieldError
            showError={true}
            errorComponent={React.createElement('span', {}, '用户名或密码不正确。请再试一次。')}
          />
        : null}

        <header className={styles.loginHeader}>
          输入您的UA MapMyRun账号
        </header>

        <CharField
          slim
          name='email'
          placeholder='电子邮件'
          labelComponent={null}
          className={styles.inputEmail}
          errorComponent={React.createElement('span', {}, '必须提供电子邮件。')}
          disabled={loggingIn}
          normalize={(value) => value.trim()}
        />

        <CharField
          slim
          name='password'
          type='password'
          placeholder='密码'
          labelComponent={null}
          className={styles.inputPassword}
          errorComponent={React.createElement('span', {}, '必须填写密码。')}
          disabled={loggingIn}
          normalize={(value) => value.trim()}
        />

        <CheckboxField
          bold
          name='agreement'
          value='agreement'
          className={styles.agreement}
          errorComponent={React.createElement('span', {}, '开始迁移数据前需要你同意隐私政策和使用条款。')}
          labelComponent={
            this.props.confirmPage ?
              <div className={styles.agreementLinksContainer}>
                我同意并接受以上条款
              </div>
              :
                <div className={styles.agreementLinksContainer}>
                  本人接受条款，并同意Under Armour出于提供服务之目的，按照 <a className={styles.agreementLinks} href="http://about.mapmyfitness.com/about/user-privacy-policy/">隐私政策</a>和<a className={styles.agreementLinks} href="http://about.mapmyfitness.com/under-armour-record-terms-and-conditions-of-use/">条款</a>的详细描述，处理我的个人数据（包括健康状况和地理位置数据）。本人可以随时撤销此同意书。
                </div>
          }
        />

        <Button
          el='button'
          type='success'
          disabled={loggingIn}
          className={styles.button}
        >
          转移数据
        </Button>
        <SvgSpriteSheet />
      </form>
    )
  }

}

export const Form = reduxForm(formOptions)(MigrateForm)

export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(Form)
